export type UserType = 'Parent' | 'Student'

export type SenderID = string
export type SenderUID = `${SenderID}${UserType}`

export type RecipientID = string
export type RecipientUID = `${RecipientID}${UserType}`

type UID = SenderUID | RecipientUID

export const createUID = (id: SenderID | RecipientID, type: UserType): UID => `${id}${type}`
export const getIdFromUID = (uid: UID) => parseInt(uid, 10)
export const getUserTypeFromUID = (uid: UID) => {
  return uid.replace(/\d/g, '') as UserType
}

export const isParent = (uid: UID) => {
  return getUserTypeFromUID(uid) === 'Parent'
}
